module.exports = __webpack_public_path__ + "img/centurion_en-min.f6980afb.png";